import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { cx } from "class-variance-authority";

import * as styles from "./Radio.module.scss";

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cx(styles.group, className)}
      {...props}
      ref={ref}
    />
  );
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

type RadioGroupItemProps = {
  label?: string | React.ReactNode;
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
  labelComponent?: React.ElementType;
  size?: "default" | "small";
} & RadioGroupPrimitive.RadioGroupItemProps;

const RadioGroupItem = React.forwardRef<
  HTMLButtonElement,
  RadioGroupItemProps
>(
  (
    {
      className,
      id,
      label,
      labelProps,
      labelComponent,
      size = "default",
      ...props
    },
    ref,
  ) => {
    const LabelComponent = labelComponent ?? "label";

    return (
      <div className={styles.itemContainer}>
        <RadioGroupPrimitive.Item
          id={id}
          ref={ref}
          className={cx(
            styles.item,
            {
              [styles.disabled]: props.disabled,
              [styles.small]: size === "small",
            },
            className,
          )}
          {...props}
        >
          <RadioGroupPrimitive.Indicator className={styles.indicator} />
        </RadioGroupPrimitive.Item>
        {label && (
          <LabelComponent
            htmlFor={id}
            className={cx(styles.label, {
              [styles.disabled]: props.disabled,
            })}
            {...labelProps}
          >
            {label}
          </LabelComponent>
        )}
      </div>
    );
  },
);
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
